import { defineStore } from 'pinia'
import axios from 'axios';

// You can name the return value of `defineStore()` anything you want, but it's best to use the name of the store and surround it with `use` and `Store` (e.g. `useUserStore`, `useCartStore`, `useProductStore`)
// the first argument is a unique id of the store across your application
export const useMainStore = defineStore('main', {
    state: () => ({ 
      user: null,
      token: null,
      class: null,
      regions: null,
      brands: null,
      brand: null,
      region: null,
      error: null,
      toast: false,
      toastMsg: "",
      toastMode: "success",
      editMode: false,
      editID: null,
      currencySymbolRef: {
        RMB: '¥',
        USD: '$',
        GBP: '£',
        CN: '¥',
        '50': '$',
        CA: '$',
        BD: '$',
        '98': '$'
      } ,
      companyRef: {
        CN: 'China',
        '50': 'Hong Kong',
        CA: 'North America',
        BD: 'Bangladesh',
        '98': 'North America'
      } 
    
    }),
    getters: {
      isAuth(state) { //If there is a logged in user
        return !!state.user;
      },
      brandList(state) { //Filtered brands to just the names to make ir lighter
        return state.brands?.map(e => e.className)
      },
      classIDSub(state) {
        return state.user.clientId.substring(0,4)
      },
      companyId(state) {
        var reg = state.region.companyId;
        return reg;
      },
      userId(state) {
        var id = state.user.icdUserid;
        return id;
      },
      currencySymbol(state) {
        if(state.region && state.region.cCurSign) {
          return state.region.cCurSign
        }
        return '$'
      },
      currencyCode(state) {
        if(state.region && state.region.cCurCode) {
          return state.region.cCurCode
        }
        return 'USD'
      }
    },
    actions: {
      async signIn(username, password) {
        //Gets and saves the token
        await axios.post("/authorize",
      {
          username: username,
          password: password
      }
      ).then(response => this.token = response.data.accesstoken).catch(e => {this.error = e})

      if(this.token == null) {
        return;
      }

      localStorage.setItem("token",this.token)
      await this.getUser();
      
    },
    async deleteEditCart() {
      await axios.delete("orders/edit", {
        params: {
            UserId: this.userId,
            Order: this.editID,
            accesstoken: this.token
        }
    })
    this.editMode = false;
    this.editID = null;
    },
    async getUser() {
      //Calls for the users info, class, and associated brands

      if(this.token == null) {
        if(localStorage.getItem('token') == null) {
          return;
        }
        this.token = localStorage.getItem('token')
      }
      await axios.get("/user", {
        params: {
          accesstoken: this.token
        }
      }).then(response => this.user = response.data).catch(e => {this.error = e})
      
      await axios.get("/class", {
        params: {
          userId: this.user?.icdUserid,
          accesstoken: this.token
        }
      }).then(response => this.brands = response.data).catch(e =>{this.error = e})
      await axios.get("/class", {
        params: {
          classId: this.user?.clientId,
          accesstoken: this.token
        }
      }).then(response => this.class = response?.data[0]).catch(e => {this.error = e})
      //Linzy:20250819 If there is no class, we redirect to the sign in page otherwise this.regions=null resulting in an error
      if(this.class == null) {     
         this.$router.push({name: 'SignIn'})
      }
      //Defaults for each value
      this.regions = this.class.classRegions
      if(localStorage.getItem('region') == null) {
        this.region = this.regions?.[0] ? this.regions?.[0] : {companyId : '50'}
      } else if(this.regions) {
        this.region = this.regions.find(el => el.companyId == localStorage.getItem('region'))
      }
      
      this.brand = this.brands?.[0]
      
      this.deleteEditCart();
      },
      signOut() {
        //Clears the store and the localstorage
        this.user= null,
        this.token= null,
        this.class= null,
        this.regions= null,
        this.brands= null,
        this.brand= null,
        this.region= null,
        this.error= null,
        localStorage.removeItem("token")
        localStorage.removeItem("region")
        this.$router.push({name: 'SignIn'})
      },
      setBrand(brand) {
        this.brand = this.brands.find(e => e.className == brand)
      },
      setToast(msg,status) {
        this.toastMsg = msg;
        this.toastMode= status;
        this.toast= true;
        setTimeout(()=> this.toast = false, 6000)
      },
      async getCurrencyRate(code) {
        const res = await axios.get("/company/currencyrate",{
          params: {
            code: code,
            accesstoken: this.token
          }
        })
        return res.data.currencyRate;
      },
      setRegion(company) {
        this.region = company;
        localStorage.setItem('region', company.companyId);
      }
    },
  })